
  import notifications from '~/mixins/pages/mission-control/notifications'
  export default {
    name: 'Theme5DesktopNotification',
    mixins: [notifications]
  }
